import notify from "devextreme/ui/notify";

export const buildMessageFromResponse = (response) => {
  if (response.data && response.data.errors) {
    return response.data.errors.map(({message, target}) => {
      return (target && target !== "") ? message + '[' + target + ']' : message
    }).join("; ");
  }
  return response;
}

export const createError = (msg) => ({
  errors: [
    {
      target: null,
      message: msg || "Не удалсоь выполнить запрос"
    }
  ]
});

export const logError = message =>
  notify(
    {
      closeOnClick: true,
      closeOnOutsideClick: true,
      message
    },
    "error"
  );

export const logSuccess = message =>
  notify(
    {
      closeOnClick: true,
      closeOnOutsideClick: true,
      message
    },
    "success"
  );

export default {createError, logError, logSuccess}
